<template>
  <div class="channel-item-component">
    <div
      class="channel-item clearfix"
      :class="{'channel-item-active':activeChannel.code === channel.code}"
    >
      <span class="choose-icon"></span>
      <span
        class="channel-logo"
        :style="{'backgroundImage': 'url(' + channelMap[channel.code].logo + ')'}"
      ></span>
      <span class="channel-name">{{channelMap[channel.code].name}}</span>
      <span class="channel-info">
        <template v-if="channel.code === 'ALIPAY'">
          <span>支持手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
        </template>
        <template v-if="channel.code === 'ALIPAYHB_INSTALMENT'">
          <span class="recommed">分期</span>
          <span>手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
        </template>
        <template v-else-if="channel.code === 'HUIMIN_INSTALMENT'">
          <span class="recommed">分期</span>
          <span>手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
          <span>请在1小时内完成支付，否则二维码将失效</span>
        </template>
        <template v-else-if="channel.code === 'CMB_PC_QR'">
          <span>手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
          <span>请在20分钟内完成支付，否则招商二维码将失效</span>
        </template>
        <template v-else-if="channel.code === 'UNIONPAY'">
          <span>支持信用卡和储蓄卡</span>
        </template>
        <template v-else-if="channel.code === 'WECHATPAY'">
          <span class="recommed">推荐</span>
          <span>支持手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
          <span>请在2小时内完成支付，否则微信支付将失败</span>
        </template>
        <template v-else-if="channel.code === 'WEBANK_INSTALMENT'">
          <span>手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
          <span>请在30分钟内完成支付，否则二维码将失效</span>
        </template>
        <template v-else-if="channel.code === 'CMB_INSTALMENT'">
          <span>手机扫码</span>
          <img src="@/assets/images/order/mobile.png" />
          <span>请在2小时内完成支付，否则招商二维码将失效</span>
        </template>
        <template v-else-if="channel.code === 'BCM_INSTALMENT'">
          <span class="recommed">分期</span>
          <span class="recommed-small">5倍积分</span>
        </template>
        <template v-else-if="channel.code === 'ICBC_INSTALMENT'">
          <span class="recommed">分期</span>
        </template>
        <template v-else-if="channel.code === 'ZHONGJIN_CLOUDFLASH'">
          <img
            class="icon-img"
            src="@/assets/images/order/yinlian.svg"
          />
        </template>
      </span>
      <div
        class="real-price"
        v-if="realPrice && activeChannel.code === channel.code"
      >
        <span>支付</span>
        <span>{{realPrice}}</span>
      </div>
    </div>
    <div
      class="refund-fee-tip"
      v-if="channel.code === 'AIRWALLEX_CARD'"
    >
      <i class="tip-icon">!</i>
      <span>
        <span class="tip-name">VISA/MasterCard支付</span>
        <span class="tip-desc">如退费将产生手续费</span>
      </span>
    </div>
    <div
      class="installment-module"
      v-if="activeChannel.code === channel.code && channel.prices && channel.prices.length"
    >
      <!-- v-if="channel.code !== 'BAIDU_INSTALMENT'" -->
      <template>
        <div class="installment-title">选择分期数</div>
        <div class="installment-list">
          <div
            class="installment-item"
            :class="{'checked': o.checked , 'installment-item-small': channel.code === 'ICBC_INSTALMENT'}"
            v-for="(o, i) in channel.prices"
            :key="i"
            @click="changeInstallment(i)"
          >
            <template v-if="channel.code === 'BAIDU_INSTALMENT'">
              <p>¥{{o.singlePrice}}x{{o.period}}</p>
              <p>服务费¥{{o.interestPrice}}</p>
            </template>
            <template>
              <p>{{o.name}}</p>
              <p v-if="o.fee">{{o.fee}}</p>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import zfb from '@/assets/images/order/zfb.png'
import hb from '@/assets/images/order/hb.png'
import zs from '@/assets/images/order/zs.png'
import yl from '@/assets/images/order/yl.png'
import wx from '@/assets/images/order/wx.png'
import wld from '@/assets/images/order/wld.png'
import bdjr from '@/assets/images/order/bdjr.png'
import jt from '@/assets/images/order/jt.png'
import gs from '@/assets/images/order/gs.png'
import ysf from '@/assets/images/order/yunshanfu.svg'
import jhhmd from '@/assets/images/order/jhhmd.png'
import airwallexcard from '@/assets/images/order/airwallex_card.png'
import airwallexalipay from '@/assets/images/order/airwallex_alipay.png'
import airwallexwechat from '@/assets/images/order/airwallex_wechat.png'

export default {
  props: {
    channel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    activeChannel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    realPrice: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      channelMap: {
        'ALIPAY': {
          logo: zfb,
          name: '支付宝支付'
        }, // 支付宝
        'ALIPAYHB_INSTALMENT': {
          logo: hb,
          name: '花呗分期'
        }, // 花呗分期
        'CMB_PC_QR': {
          logo: zs,
          name: '招商pc扫码'
        }, // 招商pc扫码
        'UNIONPAY': {
          logo: yl,
          name: '银联支付'
        }, // 银联
        'WECHATPAY': {
          logo: wx,
          name: '微信支付'
        }, // 微信
        'WEBANK_INSTALMENT': {
          logo: wld,
          name: '微粒贷分期支付'
        }, // 微粒贷
        'CMB_INSTALMENT': {
          logo: zs,
          name: '招商信用卡分期支付'
        }, // 招行分期
        'BAIDU_INSTALMENT': {
          logo: bdjr,
          name: '有钱花教育分期'
        }, // 百度金融
        'BCM_INSTALMENT': {
          logo: jt,
          name: '交通银行信用卡支付'
        }, // 交通银行
        'ICBC_INSTALMENT': {
          logo: gs,
          name: '工商银行e支付'
        }, // 工商
        'ZHONGJIN_CLOUDFLASH': {
          logo: ysf,
          name: '银联云闪付'
        }, // 云闪付
        'HUIMIN_INSTALMENT': {
          logo: jhhmd,
          name: '交行惠民贷'
        },
        'AIRWALLEX_CARD': {
          logo: airwallexcard,
          name: 'VISA/MasterCard'
        },
        'AIRWALLEX_ALIPAY': {
          logo: airwallexalipay,
          name: '支付宝支付'
        },
        'AIRWALLEX_WECHAT': {
          logo: airwallexwechat,
          name: '微信支付'
        },
      }
    }
  },
  methods: {
    changeInstallment(index) {
      this.channel.prices.forEach((o, i) => {
        o.checked = index === i
      })
    }
  }
}
</script>

<style lang="less" scoped>
.channel-item-component {
  cursor: pointer;
  .channel-item {
    position: relative;
    height: 60px;
    line-height: 56px;
    width: 100%;
    border: 2px solid transparent;
    cursor: pointer;
    padding: 0 40px;
    color: #666;
    font-size: 12px;
    margin-top: -2px;
    span,
    img {
      float: left;
    }
    .real-price {
      position: absolute;
      right: 40px;
      top: 0;
      span {
        color: #666;
        &:last-child {
          display: inline-block;
          font-size: 14px;
          color: #f60;
          margin-left: 3px;
          font-weight: 400;
        }
      }
    }
    .choose-icon {
      width: 17px;
      height: 17px;
      background: url("../../../../assets/images/order/bg.png") no-repeat 0 -22px;
      margin-top: 20px;
      margin-right: 25px;
    }
    .channel-logo {
      height: 40px;
      width: 46px;
      font-size: 0;
      margin-top: 7px;
      background-size: 100%;
    }
    .channel-name {
      margin-left: 20px;
      width: 100px;
      height: 58px;
    }
    .channel-info {
      margin-left: 30px;
      height: 58px;
      img {
        &:not(.icon-img) {
          width: 18px;
          height: 29px;
          margin: 15px;
        }
        &.icon-img {
          width: 40px;
          margin-top: 7px;
        }
      }
      .recommed {
        color: #f60;
        font-size: 14px;
        margin-right: 10px;
      }
      .recommed-small {
        color: #f60;
        font-size: 12px;
        margin-right: 10px;
      }
    }
    &:hover {
      border-color: #ffa970;
    }
    &.channel-item-active {
      border-color: #f60;
      .choose-icon {
        background-position: -20px -22px;
      }
    }
  }
  .refund-fee-tip {
    display: flex;
    align-items: center;
    margin: 0 40px 12px;
    padding: 10px 12px;
    background: rgba(255, 243, 236, 1);
    border-radius: 10px;
    border: 1px solid #FF6422;
    color: #FF6422;
    font-size: 12px;
    line-height: 18px;
    .tip-name {
      color: #4B525C;
    }
    .tip-desc {
      color: #FF6422;
    }
    .tip-icon {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      margin-right: 6px;
      border-radius: 50%;
      background: #FF6422;
      color: #fff;
      font-size: 10px;
      font-style: normal;
      line-height: 14px;
      text-align: center;
    }
  }
  .installment-module {
    padding: 0 40px 20px;
    border: 2px solid transparent;
    margin-top: -2px;
    .installment-title {
      font-size: 12px;
      color: #999;
      margin-top: 20px;
    }
    .installment-list {
      margin-top: 10px;
      .installment-item {
        display: inline-block;
        margin-left: 20px;
        width: 252px;
        height: 80px;
        border: 1px solid #e6e6e6;
        text-align: center;
        p:first-child {
          margin-top: 15px;
          color: #333;
          font-size: 16px;
          line-height: 24px;
        }
        p:last-child {
          color: #999;
          font-size: 12px;
          margin-top: 6px;
        }
        &.installment-item-small {
          height: 40px;
          width: 80px;
          margin-left: 0;
          margin-right: 20px;
          p {
            margin: 0;
            line-height: 38px;
            color: #333;
            font-size: 16px;
          }
        }
        &.checked {
          border-color: #ff6422;
          border-width: 2px;
          background-color: #fff4ef;
        }
      }
    }
    .bd-module {
      .input-module {
        input {
          float: left;
          border: 1px solid #e6e6e6;
          font-size: 14px;
          height: 50px;
          outline: 0 none;
          padding-left: 20px;
          color: #333;
          width: 48%;
          margin: 10px 0;
          &:nth-of-type(2) {
            float: right;
          }
          &:nth-of-type(3) {
            width: 100%;
          }
        }
      }
      .installment-list {
        .installment-item {
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    &:hover {
      border-color: #ffa970;
    }
  }
}
</style>
